import { render, staticRenderFns } from "./mytpp-questionnaires.vue?vue&type=template&id=06d8c777&scoped=true"
import script from "./mytpp-questionnaires.vue?vue&type=script&lang=js"
export * from "./mytpp-questionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8c777",
  null
  
)

export default component.exports